import { useSelector } from "react-redux";
import { getCurrentUser } from "../helpers/selectors";

export const useHelpCenterRights = () => {
  const { username } = useSelector(getCurrentUser) || {};
  return {
    canEdit: [
      "adm-carl-johan.lundberg@kommunalse.onmicrosoft.com",
      "admin@uniqueue.se",
      "cj.mika@mikasverige.se",
      "daniel@mikasverige.se",
      "devops@kommunal.se",
    ].includes((username || "").toLowerCase())
  };
};
